import React from "react";
import { Container } from "react-bootstrap";
import FirstImage from "../../assets/images/svg/aboutFirst.svg";
import SecondImage from "../../assets/images/svg/aboutSecond.svg";
import ThirdImage from "../../assets/images/svg/aboutThird.svg";
import FourthImage from "../../assets/images/svg/aboutFourth.svg";
import FifthImage from "../../assets/images/svg/aboutFifth.svg";
import SHTText from "../../components/SHTText";
import "../../assets/styles/page/about_featured_style.css";
const AboutSection = () => {
  return (
    <Container>
      <section
        className="d-md-flex justify-content-between d-sm-block sht_container_space about_section_container "
        style={{ marginTop: 100, marginBottom: 100 }}
      >
        <div className="half_part">
          <div>
            <img
              src={FirstImage}
              alt="Image of a guy runing with a football"
              className="first_image"
            />
            <div className="my-5">
              <SHTText
                size="h1"
                text="INSPIRATION FOR FUTURE PLAYERS"
                color="white"
              />
            </div>
            <div className="my-3 ">
              <SHTText
                size="p"
                text="The Showtime Flag Football League (SFFL) is a captivating football league that brings together the best football talent from around the world. Known for its rich football tradition and love for the game, the Showtime Flag provides an unparalleled platform for showcasing exceptionalskills,  fierce competition, and unforgettable moments."
                color="gray"
              />
            </div>
            <div className="my-3 ">
              <SHTText
                size="p"
                text="The Showtime Flag places great emphasis on fair play, integrity, and community engagement. Players not only showcase their skills on the field but also actively contribute to the local community through charitable initiatives and outreach programs. The league takes pride in nurturing not only outstanding athletes but also exceptional individuals who inspire and uplift those around them."
                color="gray"
              />
            </div>
            <div className="my-3 ">
              <SHTText
                size="p"
                text="The Showtime Flag Football League (SFFL) is a  captivating football league that brings together the best football talent from around the world. Known for its rich football tradition and love for the game, the Showtime Flag provides an unparalleled platform for showcasing exceptionalskills,  fierce competition, and unforgettable moments."
                color="gray"
              />
            </div>
          </div>
        </div>
        <div className="half_part">
          <div>
            <SHTText size="h4" text="WHO WE ARE" color="white" />
            <SHTText size="h2" text="ABOUT THE LEAGUE" color="white" />
          </div>
          <div className="py-3">
            <SHTText
              size="p"
              text="The Showtime Flag Football League (SFFL) is a captivatingfootball league that brings together the best football talent from around the world. Known for its rich football tradition and love for the game, the Showtime Flag provides an unparalleled platform for showcasing exceptional skills, fierce competition, and unforgettable moments."
              color="gray"
            />
          </div>
          <div className="d-flex justify-content-between my-4">
            <img
              src={SecondImage}
              alt="two people running"
              className="second_image"
            />
            <img
              src={ThirdImage}
              alt="a lady trying to gain the ball from a guy while running"
              className="third_image"
            />
          </div>

          <div className="my-5">
            <SHTText size="h4" text="DIVISION ONE" color="white" />
            <div className="my-3">
              <SHTText
                color="gray"
                text="Division One of the Showtime Flag Football League represents the pinnacle of competition within the league.The division features of the most skilled and accomplished players, showcasing their exceptional talents on the field. "
                size="p"
              />
            </div>
          </div>
          <div className="my-4">
            <img
              src={FourthImage}
              alt="Group of players shakig hands"
              width="100%"
            />
          </div>

          <div className="my-5">
            <SHTText size="h4" text="DIVISION TWO" color="white" />
            <div className="my-3">
              <SHTText
                color="gray"
                text="Division One of the Showtime Flag Football League represents the pinnacle of competition within the league.The division features of the most skilled and accomplished players, showcasing their exceptional talents on the field.  "
                size="p"
              />
            </div>
          </div>
          <div className="my-4">
            <img
              src={FifthImage}
              alt="Group of players training"
              width="100%"
            />
          </div>
        </div>
      </section>
    </Container>
  );
};

export default AboutSection;
